const DEFAULT_MESSAGE = "Something went wrong, try again";

const formatApiError = (detail: unknown): string => {
	if (!detail) return DEFAULT_MESSAGE;

	if (typeof detail === "string") return detail || DEFAULT_MESSAGE;

	if (Array.isArray(detail)) {
		return detail.join(", ") || DEFAULT_MESSAGE;
	}

	if (typeof detail === "object" && "detail" in detail) {
		const msg = String((detail as Record<string, unknown>).detail);
		return msg && msg !== "null" && msg !== "undefined" ? msg : DEFAULT_MESSAGE;
	}

	const entries = Object.entries(detail as Record<string, unknown>);
	if (!entries.length) return DEFAULT_MESSAGE;

	return entries
		.map(
			([field, errors]) =>
				`${field}: ${Array.isArray(errors) ? errors.join(", ") : errors}`
		)
		.join("; ");
};

export default formatApiError;
